module.exports = __webpack_public_path__ + "7b99efd0f9d544e8b23ad52a9a9a90d3.MP3";